export const CURRENT_URL = `${window.location.protocol}//${window.location.host}`;
export const API_URL = `${CURRENT_URL}/wp-json/tmt-insurance/v1`;

const registerUrl = `${API_URL}/register`;
const registerAndJoinUrl = `${registerUrl}/join`;

export const registerAndJoin = async (formData, eventId, extras) => {
  const response = await fetch(registerAndJoinUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-WP-Nonce": tmtUser.nonce,
    },
    body: JSON.stringify({
      ...formData,
      extras: extras,
      event_id: eventId,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.log(errorData);
    throw new Error(errorData.message || `Error: ${response.status}`);
  }

  const json = await response.json();
  return json;
};

// export const checkin = async (userId, eventId, key, code) => {
//   const response = await fetch(checkinUrl, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "X-WP-Nonce": tmtUser.nonce,
//     },
//     body: JSON.stringify({
//       user: userId,
//       event: eventId,
//       key: key,
//       code: code,
//     }),
//   });

//   if (!response.ok) {
//     throw new Error(`Response status: ${response.status}`);
//   }

//   const json = await response.json();
//   return json;
// };
